import { Outlet } from 'react-router-dom';

export function ConnectorsLayout() {
  return <Outlet />;
}
